import { useEffect, useState } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { authenticationService } from '../services/authenticationService';
import { useSubscriptionStatus } from './useSubscriptionStatus';
import HelperFunctions from '../helpers/HelperFunctions';
import Loader from '../templates/Loader';
import SeoHelmet from '../templates/SeoHelmet';
import FeedbackButton from '../components/FeedbackButton';

// skipSubscriptionCheck: for routes that must stay reachable by a logged-in
// user who doesn't (yet) have an active subscription - the sign-up-finish
// flow itself, and account/billing pages a lapsed user needs to fix things.
const PrivateRoute = ({ element: Component, requiredPermissions: array, skipSubscriptionCheck = false }) => {
 // const [currentUser] = useCurrentUser();

  const [currentUser, setCurrentUser] = useState(null);
  const [initialised, setInitialised] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { doesUserHaveSubscription } = HelperFunctions();
  const { subscriptionData, status: subscriptionStatus } = useSubscriptionStatus();

   useEffect(() => {
    const subscription = authenticationService.currentUser.subscribe(user => {
      //login is pre permissions work
      //force them to log back in
      if(user && !user.permissions) {
        authenticationService.logout();
      }
      setCurrentUser(user);
      setInitialised(true);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (!initialised) {
    return <div className='vh-100 center-content'><Loader /></div>; // loader/spinner
  }

  const containsAny = (arr1, arr2) => arr1.some(item => arr2.includes(item));

  //needs a current user that has the requisite permissions
  if (!currentUser || (array && !containsAny(array, currentUser.permissions ?? []))) {
    //authenticationService.logout();
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Same subscription gating as HomeRouter's "/" logic, so a bookmarked or
  // post-login deep link into a private route can't bypass it.
  if (!skipSubscriptionCheck
      && searchParams.get('checkout-complete') !== 'saas-subscription'
      && !doesUserHaveSubscription(currentUser.roles)) {
      
    

    // Still waiting on the Stripe subscription fetch - don't route until we
    // know whether there's a lapsed subscription or none at all.
    if (subscriptionData === null || subscriptionData.status === null) {
      return <div className='vh-100 center-content'><Loader /></div>;
    }

   
    if (subscriptionStatus && subscriptionStatus !== 'active' && subscriptionStatus !== 'trialing') {
      return <Navigate to="/trial-expired" state={{ from: location }} />;
    }
    return <Navigate to="/sign-up/finish" state={{ from: location }} />;
  }

  // Every private route is auth-gated and must never be indexed. noindex,nofollow (not
  // "follow") so crawlers don't try to follow links deeper into authenticated areas. This
  // one place covers all private routes; self-canonical is moot under noindex but tidy.
  return (
    <>
      <SeoHelmet noindex nofollow slug={location.pathname} />
      <FeedbackButton />
      <Component />
    </>
  );
};

export default PrivateRoute;
